import React from 'react';
import { Button as SharedButton } from '@mss/mss-component-library';

const Button = (props: React.ComponentProps<typeof SharedButton>) => (
  <SharedButton theming="site" {...props} />
);

export default Button;
